var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("labels.title") },
                    model: {
                      value: _vm.value.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Name", $$v)
                      },
                      expression: "value.Name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-color-picker", {
                    attrs: {
                      color: _vm.value.Color,
                      label: _vm.$ct("labels.background-color"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Color,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Color", $$v)
                      },
                      expression: "value.Color",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-time", {
                    attrs: {
                      value: _vm.minTime,
                      fancy: "",
                      label: _vm.$ct("min-time-in-per-calendar-view"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setMinTime($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-time", {
                    attrs: {
                      value: _vm.maxTime,
                      fancy: "",
                      label: _vm.$ct("max-time-in-per-calendar-view"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setMaxTime($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save", disabled: !_vm.isValid },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t(_vm.saveLabelKey)) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }